<template>
  <Dropdown>
    <a class="box-mode-trigger" @click.prevent>
      {{ label }} <DownOutlined />
    </a>
    <template #overlay>
      <Menu @click="handleClick">
        <MenuItem v-for="opt in options" :key="opt.value">{{ opt.label }}</MenuItem>
      </Menu>
    </template>
  </Dropdown>
</template>
<script lang="ts" setup name="BoxModeSwitch">
  import { computed } from 'vue'
  import { Dropdown, Menu, MenuItem } from 'ant-design-vue'
  import { DownOutlined } from '@ant-design/icons-vue'
  import { lang } from '@jms/utils'

  const props = defineProps<{ mode?: string }>()

  const emit = defineEmits(['update:mode'])

  const options = [
    { label: lang('单个快递柜'), value: 'single' },
    { label: lang('批量快递柜'), value: 'multiple' }
  ]

  const label = computed(() => options.find((o) => o.value === props.mode)?.label ?? '')

  const handleClick = ({ key }: any) => {
    emit('update:mode', key)
  }
</script>
<style lang="less" scoped>
  .box-mode-trigger {
    cursor: pointer;
    color: #6e6e6e;
  }
</style>